import React from "react";

class FlatButton extends React.Component {
  render() {
    return (
      <button className="FlatButton" onClick={() => this.props.onClick()}>
        {this.props.label}
      </button>
    );
  }
}

export default FlatButton;



// WEBPACK FOOTER //
// ./src/components/FlatButton.js